import React from "react";
import HomeModern from "./home-modern/Home";

const ResponsiveManager = () => {
  return <HomeModern />;
};

export default ResponsiveManager;
